import React from 'react';
import { useAuthContext } from 'hooks/useAuthContext';

interface RoleGuardProps {
  requiredRoles: string[];
  children: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ requiredRoles, children }) => {
  const { userState } = useAuthContext();

  if (!userState.isAuthenticated || !userState.user.userId) {
    return null;
  }

  const hasRequiredRole = requiredRoles.some(role => role === userState.user.selectedWorkspace.userRole);

  if (!hasRequiredRole) {
    return null;
  }

  return children;
};

export default RoleGuard;
